import { ObservedValueOf, of, OperatorFunction, Observable, combineLatest, isObservable } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { Single } from "../../../interfaces/single.interface";
import { GraphQLComparision } from "../../../enums/GraphQLComparision.enum";
import { GraphQlQueryResult } from "../query-executor/graphql-query-executor.operator";


export function GraphQlQueryResultToNgxSingle(nameTemplate: String | Observable<String>, valueAccessor: ValueAccessor): OperatorFunction<GraphQlQueryResult, Single[]> {


  return switchMap(graphQlQueryResult => (isObservable(nameTemplate) ? nameTemplate : of(nameTemplate)).pipe(
    map(_nameTemplate => {
      var nameFunc = new Function(`return \`${nameTemplate}\`;`);

      const query = graphQlQueryResult.graphQlQuery;
      const result = graphQlQueryResult.result;

      const data = result.data[query.dataset].items.map(i => {



        return {
          name: nameFunc.call(i),
          value: valueAccessor(i),
          data: i,
          query: query,
          wheres: query.groupBys.map(g => {


            if (g.timeUnit != null) {

              var from = new Date(i[g.path]);
              var to = new Date(i[g.path]);

              if (g.timeUnit == "HOURS") to.setHours(from.getHours() + 1);
              else if (g.timeUnit == "DAYS") to.setDate(from.getDate() + 1);
              else throw "Failed";

              return [
                { path: g.path, comparison: GraphQLComparision.GREATER_THAN_OR_EQUAL, value: "" + i[g.path] },
                { path: g.path, comparison: GraphQLComparision.LESS_THAN, value: "" + to.toJSON() }
              ]
            }


            return [{ path: g.path, comparison: GraphQLComparision.EQUAL, value: i[g.path] }];
          }).flat()
        };
      });

      return data;
    })
  ));

}

interface ValueAccessor {
  (data: any): number;
}
